import { createContext, useContext } from 'react';
export var ReferenceRecordContext = createContext(null);
export var ReferenceRecordContextProvider = ReferenceRecordContext.Provider;
export var useReferenceRecordContext = function () {
    return useContext(ReferenceRecordContext);
};
